// backoffice/src/config/api.js

const API_URL = process.env.REACT_APP_API_URL; // Assurez-vous que REACT_APP_API_URL est bien défini dans votre .env et pointe vers votre backend (ex: http://localhost:3000)

const API = {
  ADMIN: {
    LOGIN: `/api/v1/auth/admin/email/login`,
  },
  USERS: {
    GETUSERS: `/api/v1/users`,
    ADDUSER: `/api/v1/users`,
    DELETEUSER: `/api/v1/users`,
    GETUSERBYID: `/api/v1/users`,
    UPDATEUSER: `/api/v1/users`,
  },
  DELEGATES: {
    GETDELEGATES: `/api/v1/delegates`,
    ADDDELEGATE: `/api/v1/delegates`,
    GETDELEGATEBYID: `/api/v1/delegates`,
    UPDATEDELEGATE: `/api/v1/delegates`,
  },
  SPECIALTYS: { 
    GETSPECIALTYS: `/api/v1/specialtys`,
    ADDSPECIALTY: `/api/v1/specialtys`,
    DELETESPECIALTY: `/api/v1/specialtys`,
    GETSPECIALTYBYID: `/api/v1/specialtys`,
    UPDATESPECIALTY: `/api/v1/specialtys`,
  },
  REGIONS: {
    GETREGIONS: `/api/v1/regions`,
    ADDREGION: `/api/v1/regions`,
    DELETEREGION: `/api/v1/regions`,
    GETREGIONBYID: `/api/v1/regions/`, 
    UPDATEREGION: `/api/v1/regions`,
    FILTERREGION: `/api/v1/regions/filter`,
    MERGE: `/api/v1/regions/merge`
  },
  GOVERNMENTS: {
    GETGOVERNMENTS: `/api/v1/governments`,
    ADDGOVERNMENT: `/api/v1/governments`,
    DELETEGOVERNMENT: `/api/v1/governments`,
    GETGOVERNMENTBYID: `/api/v1/governments/`, 
    UPDATEGOVERNMENT: `/api/v1/governments`,
    FILTERGOVERNMENT: `/api/v1/governments/filter`,
  },
  PERSONS: {
    GETPERSONS: `/api/v1/persons`,
    ADDPERSON: `/api/v1/persons`,
    DELETEPERSON: `/api/v1/persons`,
    GETPERSONBYID: `/api/v1/persons/`, // Idem
    GETPERSONBYTYPE: `/api/v1/persons/type/`, // Idem
    UPDATEPERSON: `/api/v1/persons`,
    FILTERPERSON: `/api/v1/persons/filter`,
  },
  PRODUCTS: {
    GETPRODUCTS: `/api/v1/products`,
    ADDPRODUCT: `/api/v1/products`,
    DELETEPRODUCT: `/api/v1/products`,
  },
  RAPPORTS: {
    GETRAPPORTS: `/api/v1/reports`,
  },
  SAMPLE : { // Renommé en SAMPLES pour la cohérence, si souhaité. Si non, gardez SAMPLE.
    GETSAMPLES: `/api/v1/samples`, // Si vous avez gardé SAMPLE, le thunk devrait utiliser API.SAMPLE.GETSAMPLES
  },

 // --- OBJET MIS À JOUR ---
  GIVEN_SAMPLES: {
    GET_SUMMARY: `/api/v1/given-samples-summary`,
    GET_ALL_KPIS: `/api/v1/given-samples-summary/kpis`,
    GET_DELEGATE_PIVOT_BASE: `/api/v1/given-samples-summary/delegate-pivot`,
    // --- AJOUTER CES DEUX LIGNES ---
    EXPORT_SUMMARY: `/api/v1/given-samples-summary/export/csv`,
    EXPORT_DELEGATE_PIVOT_BASE: `/v1/given-samples-summary/delegate-pivot`, // Note: export va sur la même base, on ajoute juste '/export/csv' dans le thunk
  },
  IMPORT: {
    IMPORTDOCTORS: `/api/v1/persons/import/doctors?format=csv`,
    IMPORTOTHERS: `/api/v1/persons/import/others?format=csv`,
  },
};

export { API , API_URL};